import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'HalloweenEventLevelPopupSideMenuLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '15f458b5-ee3b-4de5-b81e-94b289d5d324',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '6874a039-c478-4353-b389-0765cf8dffe6',
      type: 'NineSlicePlane',
      name: 'bg',
      nameSpace: '',
      className: '',
      x: 15,
      y: -14,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 355,
      height: 588,
      leftWidth: 125,
      topHeight: 125,
      rightWidth: 125,
      bottomHeight: 125,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Halloween_top_list',
      parent: '15f458b5-ee3b-4de5-b81e-94b289d5d324',
      data: ''
    },
    {
      id: 'baf74143-31c8-44b8-9f0a-7f07d149baf2',
      type: 'Text',
      name: 'sideTitleText',
      nameSpace: '',
      className: '',
      x: 216,
      y: 30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'TopList',
      localize: true,
      maxWidth: 247,
      maxHeight: 52,
      maxFontSize: 34,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#1e3763',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '15f458b5-ee3b-4de5-b81e-94b289d5d324',
      data: ''
    },
    {
      id: 'c08858b5-7a79-4e78-81b0-a35e3079203b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 223,
      y: 567,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blank',
      parent: '15f458b5-ee3b-4de5-b81e-94b289d5d324',
      data: ''
    },
    {
      id: 'aaadd3ab-e8c9-49e9-9343-5f072d29822e',
      type: 'Container',
      name: 'friendsContainer',
      nameSpace: '',
      className: '',
      x: 88,
      y: 90,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '15f458b5-ee3b-4de5-b81e-94b289d5d324',
      data: ''
    },
    {
      id: '5205ad50-8719-4dab-a306-4c55c75e60f5',
      type: 'Container',
      name: 'noFriendsContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '15f458b5-ee3b-4de5-b81e-94b289d5d324',
      data: ''
    },
    {
      id: '39537fa5-d66a-455c-9db3-3472a4bc5996',
      type: 'Sprite',
      name: 'inviteButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_small_blue',
      parent: 'c08858b5-7a79-4e78-81b0-a35e3079203b',
      data: ''
    },
    {
      id: '90702df7-4773-4329-bfc5-fc65092c9775',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 203,
      y: 280,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_friends_banner_right',
      parent: '5205ad50-8719-4dab-a306-4c55c75e60f5',
      data: ''
    },
    {
      id: 'aa6bb3dd-2e21-4a8b-98b3-10c4314026e9',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 214,
      y: 160,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'InviteFriends',
      localize: true,
      maxWidth: 260,
      maxHeight: 185,
      maxFontSize: 25,
      icons: [],
      style: {
        fontSize: 25,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#91317e',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 2,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '5205ad50-8719-4dab-a306-4c55c75e60f5',
      data: ''
    },
    {
      id: '11bdac68-f9f7-4441-ad96-6430eab11af8',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Invite',
      localize: true,
      maxWidth: 170,
      maxHeight: 59,
      maxFontSize: 52,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#435EF1',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '39537fa5-d66a-455c-9db3-3472a4bc5996',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class HalloweenEventLevelPopupSideMenuLayout {
  static raw = raw;
  root: PIXI.Container
  bg: PIXI.NineSlicePlane
  sideTitleText: PIXI.Text
  inviteButton: PIXI.Sprite
  friendsContainer: PIXI.Container
  noFriendsContainer: PIXI.Container

  constructor() {
    populate(this, raw);
  }
}
